import { v2Request } from "./v2Client";

const store = new Map();
const inflight = new Map();

export const OVERVIEW_TTL_MS = 45_000;
export const SESSION_TTL_MS = 60_000;
export const TREND_TTL_MS = 120_000;
export const MUSCLE_TTL_MS = 300_000;

export function v2CacheKey(path) {
  return String(path || "");
}

export function clearV2Cache(prefix = "") {
  for (const key of [...store.keys()]) {
    if (!prefix || key.startsWith(prefix)) store.delete(key);
  }
}

export async function v2FetchCached(path, { ttlMs = OVERVIEW_TTL_MS, force = false, signal } = {}) {
  const key = v2CacheKey(path);
  if (!force) {
    const hit = store.get(key);
    if (hit && hit.expiresAt > Date.now()) {
      return hit.data;
    }
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const request = (async () => {
    const data = await v2Request(path, { signal });
    store.set(key, { data, expiresAt: Date.now() + ttlMs });
    return data;
  })();

  inflight.set(key, request);
  try {
    return await request;
  } finally {
    inflight.delete(key);
  }
}
